module.exports = __webpack_public_path__ + "static/media/29COICT2.41639d26.jpg";